import { PROD_HOST, TAKAFUL } from '@/constants';
import { AgentCode, AgentTypeName } from '@/enums';
import { getHost, useRouteSection } from '@/hooks/useRouteSection';
import { getCountryCode } from '@/helpers/CountryCodeHelper';
import { HomePageLink } from '@/helpers/DocumentHelper';
import { withPrefix } from '@/helpers/WithPrefix';
import { useAppSelector } from '@/hook';
import Etiqalogo from '@/images/Etiqa_logos_Full Colour.png';
import logo from '@/images/MBB Logo.png';
import logoBkRMEn from '@/images/bkrm-logo-en.png';
import logoBkRMBm from '@/images/bkrm-logo-my.png';
import { devices } from '@/theme/device';
import { Col, Container, Navbar, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import LanguageSwitcher from '../../common/LanguageSwitcher';
import { useState, useEffect, useMemo } from 'react';
import { useLanguage } from '../../../hooks/useLanguage';

const Header = () => {
  const { t } = useTranslation();
  const host = getHost() || '';
  const routeSection = useRouteSection();
  const entity = routeSection;
  const takafulRoute = entity === TAKAFUL;
  const language = useLanguage();
  const [logoBkRM, setLogoBkRM] = useState(logo);
  const affilitateState = useAppSelector((state) => state.affilitator);


  const isDirectAgent = affilitateState.isDirectAgent;

  const isProd = host.toLowerCase().includes(PROD_HOST.toLowerCase());
  const prodAgentCodes = [AgentCode.ProdBkrmTakaful, AgentCode.ProdBKRM2Takaful];
  const uatAgentCodes = [AgentCode.UatBkrmTakaful, AgentCode.UatBKRM2Takaful];

  const validBkrmAgentCode = isProd
    ? prodAgentCodes.includes(affilitateState.agentCode)
    : uatAgentCodes.includes(affilitateState.agentCode);


  const bkrmRoute = validBkrmAgentCode && !isDirectAgent && takafulRoute; 

  useEffect(() => {
    setLogoBkRM(
      language === 'en'
        ? logoBkRMEn
        : logoBkRMBm,
    );
  }, [language]);

  const styleLogo = {
    Default: {
      width: '8rem',
      '@media only screen and (max-width: 480px)': {
        marginLeft: '1rem',
      },
      '@media only screen and (min-width: 481px) and (max-width: 768px)': {
        marginLeft: '5rem',
      },
      '@media screen and (max-width: 620px)': {
        width: '8rem',
      },
    },
    BkRM: {
      width: '12rem',
      '@media only screen and (max-width: 480px)': {
        marginLeft: '1rem',
      },
      '@media only screen and (min-width: 481px) and (max-width: 768px)': {
        marginLeft: '5rem',
      },
      '@media screen and (max-width: 620px)': {
        width: '8rem',
      },
    },
  };

  const srcLogo = {
    Default: Etiqalogo,
    BkRM: logoBkRM,
  };

  const getRow = useMemo(() => {
    if (affilitateState.type === AgentTypeName.Agent) {
      return {
        alignItems: 'center',
      };
    };

    if (affilitateState.type === AgentTypeName.Banca) {
      return {
        backgroundColor: 'rgb(252,196,12)',
      };
    };

    return null;
  }, [affilitateState.type]);

  const getLogo = useMemo(() => {
    if (bkrmRoute) {
      return {
        style: styleLogo.BkRM,
        src: srcLogo.BkRM,
      };
    }

    return {
      style: styleLogo.Default,
      src: srcLogo.Default,
    }
  }, [bkrmRoute, styleLogo, srcLogo]);

  return (
    <Container fluid>
      {affilitateState.type === AgentTypeName.Banca ? (
        <Row style={getRow}>
          <Col>
            <Logo
              src={withPrefix(logo)}
              alt="Logo"
              width="100%"
              height="100%"
            />
          </Col>
          <Col>
            <div className="text-end mt-3 pt-1 mb-3">
              Branch Code: {affilitateState.bancaBranchCode} PF Number:{' '}
              {affilitateState.salesPfNumber} <LanguageSwitcher />
            </div>
          </Col>
        </Row>
      ) : affilitateState.type === AgentTypeName.Agent ? (
        // Add content for Agent type here
          <Row style={getRow}>
          <Col>
            <Logo
                src={withPrefix(getLogo.src)}
              alt="Logo"
                style={getLogo.style}
            />
          </Col>
          <Col>
            <div className="text-end mt-3 pt-1 mb-3">
              Agent Code: {affilitateState.agentCode} Agent Branch Code:{' '}
              {affilitateState.agentBranchCode} <LanguageSwitcher />
            </div>
          </Col>
        </Row>
      ) : (
        <Navbar className="d-flex pt-1">
          <Navbar.Brand
            href={t(HomePageLink[getCountryCode()])}
            style={{ flex: 1 }}
          >
            <Logo
              src={withPrefix(Etiqalogo)}
              alt="Logo"
              width="100%"
              height="100%"
              style={{
                width: '6rem',
              }}
            />
          </Navbar.Brand>

          <div className="text-end">
            <LanguageSwitcher />
          </div>
        </Navbar>
      )}
    </Container>
  );
};

export default Header;

const Logo = styled.img`
  width: 16rem;
  @media only screen and ${devices.xs} {
    margin-left: 1rem;
  }
  @media only screen and ${devices.md} {
    margin-left: 5rem;
  }
  @media screen and (max-width: 620px) {
    width: 8rem;
  }
`;

const EtiqalogoStyle = {
  width: '8rem',
  '@media only screen and (max-width: 480px)': {
    marginLeft: '1rem',
  },
  '@media only screen and (min-width: 481px) and (max-width: 768px)': {
    marginLeft: '5rem',
  },
  '@media screen and (max-width: 620px)': {
    width: '8rem',
  },
};
